<template>
  <div
    class="overflow-hidden rounded-lg border bg-white"
    :class="link !== null ? 'cursor-pointer hover:bg-muted/50' : ''"
    @click="redirect"
  >
    <div class="px-4 py-5 sm:p-6">
      <dt class="truncate text-sm font-medium uppercase tracking-wider text-muted-foreground">
        {{ translateTitle ? $t(title) : title }}
      </dt>
      <dd class="mt-1 flex items-baseline justify-between text-3xl font-extrabold text-primary">
        <slot />
        <div>
          {{ computedContent }}
        </div>

        <!-- Handle variation label -->
        <div
          v-if="variation != null"
          class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium md:mt-2 lg:mt-0"
          :class="getVariationLabelColor"
        >
          <svg
            class="-ml-1 mr-0.5 h-5 shrink-0 self-center"
            :class="(variationIcon == '' ? 'w-2' : 'w-5') + ' text-' + variationColor + '-500'"
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path fill-rule="evenodd" :d="variationIcon" clip-rule="evenodd" />
          </svg>
          <span v-if="labelSr" class="sr-only"> {{ labelSr }} </span>
          {{ variationFormatted }}
        </div>
        <!-- Handle variation label -->
      </dd>
      <slot name="bottom" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: [String, Number],
      required: true
    },
    link: {
      type: String,
      default: null
    },
    linkQuery: {
      type: Object,
      default: () => {
        return {}
      }
    },
    variation: {
      type: Number,
      default: null
    },
    translateTitle: {
      type: Boolean,
      default: true
    },
    translateContent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelSr: function () {
      if (this.variation > 0) {
        return 'Increased by'
      } else if (this.variation < 0) {
        return 'Decreased by'
      } else {
        return 'No variation'
      }
    },
    computedContent: function () {
      return this.translateContent ? this.$t(this.content) : this.content
    },
    variationFormatted: function () {
      return `${(this.variation > 0 ? '+' : '') + this.variation}%`
    },
    variationIcon: function () {
      if (this.variation > 0) {
        return 'M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z'
      } else if (this.variation < 0) {
        return 'M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z'
      } else {
        return ''
      }
    },
    variationColor: function () {
      if (this.variation > 0) {
        return 'green'
      } else if (this.variation < 0) {
        return 'red'
      } else {
        return 'gray'
      }
    },
    variationLabelColor: function () {
      let className = ''

      if (this.variation === 0) {
        className = 'bg-muted text-foreground'
      } else if (this.variation > 0) {
        className = 'bg-green-100 text-green-800'
      } else {
        className = 'bg-red-100 text-red-800'
      }
      return className
    }
  },
  methods: {
    redirect() {
      if (this.link !== null) {
        this.$router.push({ name: this.link, query: this.linkQuery })
      }
    }
  }
}
</script>
